import React, { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import './NotificationBar.css';
import { Link } from 'react-router-dom';



const NotificationBar = () => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div className="notification-bar">
            <Link to="/Trade">
                <p>
                    Become a Dealer in your region for Callistus Window Product - Connect to our consultant now!
                </p>
            </Link>

            <AiOutlineClose className="close-icon" onClick={() => setVisible(false)} />
        </div>


    );
};

export default NotificationBar;
